import React from "react";
import { Spin, Button, List, Card, Modal, Typography, Space, Divider, Row, Col } from 'antd';
import { DeleteOutlined, ShoppingCartOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom'
import firebase from "../../firebase";
import "./MobileCart.css";
import { updateItemFromSellData } from "../../utils/itemSync";

const { Text, Title } = Typography;

class MobileOtasukeCartList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      carts: [],
      last: null,
      reportPerPage: 12,
      modal: false,
      deleteCartID: null,
      deleteCartName: null
    }
  }

  getCarts = async () => {
    let collection;
    if(this.props.org && this.props.org.reseller && this.props.userOrg && this.props.userOrg.maker) {
      // manufacturer
      collection = this.props.db.collection('items_stock').doc(this.props.userOrg.id).collection('buyers').doc(this.props.org.id).collection('items')
    } else if(this.props.org && this.props.org.maker && this.props.userOrg && this.props.userOrg.reseller) {
      // Distributor/Purchase mode
      collection = this.props.db.collection('items_stock').doc(this.props.org.id).collection('buyers').doc(this.props.userOrg.id).collection('items')
    } else if(this.props.org && this.props.org.reseller && this.props.userOrg && this.props.userOrg.buyer) {
      // purchasing user
      collection = this.props.db.collection('items_sell').doc(this.props.org.id).collection('buyers').doc(this.props.userOrg.id).collection('items')
    } else if(this.props.org && this.props.org.buyer && this.props.userOrg && this.props.userOrg.reseller) {
      // Distributor/sales mode
      collection = this.props.db.collection('items_sell').doc(this.props.userOrg.id).collection('buyers').doc(this.props.org.id).collection('items')
    }

    if(this.props.org && collection){
      this.setState({ loading: true });
      let ocRef = this.props.db.collection('otasuke_carts').doc(this.props.user.id).collection('otasuke_carts').doc(this.props.org.id);
      let oc = await ocRef.get();
      if (oc.exists) {
        let ocData = oc.data();
        let hasChanged = false;

        for (let i=0; i<5; i++) {
          let ocCart = ocData[i];

          if (ocCart && this.props.userOrg) {
            let items = ocCart.items;
            if (items) {
              delete ocCart['deletedItem'];
              delete ocCart['deletedText'];
              await Promise.all(items.map(async (item) => {
                let itemSell = await collection.doc(item.id).get();
                let itemSellData = itemSell.data();

                let prevPrice = item.price;
                let prevDeletedItem = item.deletedItem;
                delete item['deletedItem'];
                delete item['deletedText'];

                if (!itemSellData) {
                  ocCart.deletedItem = true;
                  ocCart.deletedText = '販売終了商品が含まれています';
                  item.deletedItem = true;
                  item.deletedText = '販売終了商品が含まれています';
                } else if (!itemSellData['price'] || itemSellData && itemSellData['price'] && itemSellData['price'][0] && !itemSellData['price'][0]['price']) {
                  ocCart.deletedItem = true;
                  ocCart.deletedText = '要見積商品が含まれています';
                  item.deletedItem = true;
                  item.deletedText = '要見積商品が含まれています';
                } else if (itemSellData['price'] && itemSellData['price'][0] && !itemSellData['price'][0]['expiration_date']) {
                  ocCart.deletedItem = true;
                  ocCart.deletedText = '要見積商品が含まれています';
                  item.deletedItem = true;
                  item.deletedText = '要見積商品が含まれています';
                } else if (itemSellData['price'] && itemSellData['price'][0] && itemSellData['price'][0]['expiration_date']) {
                  let expiration_date = itemSellData['price'][0]['expiration_date'];
                  let expDate = expiration_date && expiration_date.toDate ? expiration_date.toDate() : (expiration_date ? new Date(expiration_date.seconds * 1000) : new Date(0));

                  if ((expDate.getTime() - this.props.dateNow) < 0) {
                    ocCart.deletedItem = true;
                    ocCart.deletedText = '価格有効期限切れ要見積が含まれています';
                    item.deletedItem = true;
                    item.deletedText = '価格有効期限切れ要見積が含まれています';
                  } else {
                    item.price = itemSellData['price'][0]['price'];
                  }
                } else {
                  item.price = itemSellData['price'][0]['price'];
                }

                if (!item.deletedItem) {
                  let changed = updateItemFromSellData(item, itemSellData);
                  if (changed) hasChanged = true;
                }
                if (prevDeletedItem !== item.deletedItem) {
                  hasChanged = true;
                }
                if (prevPrice !== item.price && (prevPrice === undefined || Number(prevPrice) !== Number(item.price))) {
                  hasChanged = true;
                }
              }));
            }
          }
        }

        if (hasChanged) {
          await ocRef.set(ocData, {merge: true});
        }

        this.setState({carts: ocData})
      }
      this.setState({ loading: false });
    }
  }

  componentDidMount() {
    this.getCarts(this.props);
    window.addEventListener('scroll', event => this.watchCurrentPosition(), true);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.org !== prevProps.org || this.props.userOrg !== prevProps.userOrg) {
      this.getCarts();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', event => this.watchCurrentPosition(), true);
  }

  watchCurrentPosition() {
    if(window.innerHeight + this.scrollTop() +20 >= document.body.clientHeight) {
      this.onReachEnd();
    }
  }

  scrollTop() {
    return Math.max(
        window.pageYOffset,
        document.documentElement.scrollTop,
        document.body.scrollTop
        );
  }

  onReachEnd = () => {
    this.getCarts(this.props);
  }

  delete = (id, title) => {
    this.setState({
      modal: true,
      deleteCartID: id,
      deleteCartName: title
    })
  }

  modalClose = (isOk) => {
    if(isOk && this.state.deleteCartID !== null){
      let cartRef = this.props.db.collection('otasuke_carts').doc(this.props.user.id)
          .collection('otasuke_carts').doc(this.props.org.id);
      cartRef.set({
        [this.state.deleteCartID]: {},
        update: firebase.firestore.Timestamp.fromDate(new Date()),
      }, { merge: true })
          .then(() => {
            this.setState({
              modal: false,
              deleteCartID: null,
              deleteCartName: null
            }, () => {
              this.getCarts();
            });
          });
    } else {
      this.setState({
        modal: false,
        deleteCartID: null,
        deleteCartName: null
      })
    }
  }

  render() {
    if (!this.props.org ) {
      return (
        <div style={{ padding: 20 }}>
          <Text>取引先を選択してください。</Text>
        </div>
      )
    }

    function n(n){
      return n > 9 ? "" + n: "0" + n;
    }

    let userType = 'seller';
    if ((this.props.userOrg && this.props.userOrg.buyer) || (this.props.userOrg && this.props.userOrg.reseller && this.props.org.maker)) {
      userType = 'buyer';
    }

    let cartsList = [];
    for(let i=0; i<5; i++){
      let cartObj = {
        cartNo: i + 1,
        id: i,
        savedData: false,
        date: '-',
        time: '',
        recipient: '-',
        cartName: '-',
        amount: 0,
        contentDescriptions: [],
        deletedDescriptionList: [],
        archiveMode: ''
      };

      if(this.state.carts[i] && this.state.carts[i].items){ 
        cartObj.savedData = true;
        let items = this.state.carts[i].items;
        cartObj.cartName = this.state.carts[i].cartName || '名称未設定';
        cartObj.recipient = this.state.carts[i].toUserName || '-';
        let deletedItem = this.state.carts[i].deletedItem;
        let d = [];
        let deletedDescNodes = [];
        let archive = '';
        let amount = 0;
        let contentItems = [];

        if (this.state.carts[i].latestUpdate) {
          cartObj.date = this.state.carts[i].latestUpdate.toDate().getFullYear() + '/'
              + n(this.state.carts[i].latestUpdate.toDate().getMonth() + 1) + '/'
              + n(this.state.carts[i].latestUpdate.toDate().getDate());
          cartObj.time =  n(this.state.carts[i].latestUpdate.toDate().getHours()) + ':'
              + n(this.state.carts[i].latestUpdate.toDate().getMinutes());
        }

        items.forEach((item, index) => {
          if (!item.deletedItem) {
            amount += (item.price*item.count);
          } else {
            if (!d.includes(item.deletedText)) {
              d.push(item.deletedText)
              deletedDescNodes.push(<div key={`del-${index}`}><Text type="danger">{item.deletedText}</Text></div>)
            }
          }
          contentItems.push(<div key={`item-${index}`}><Text>{item.name}</Text></div>);

          if (item.archive) {
            if (userType === 'seller') {
              archive = <div key={`arch-${index}`}><Text type="danger">アーカイブ商品が含まれています</Text></div>
            } else {
              archive = <div key={`arch-${index}`}><Text type="danger">取扱していない商品が含まれています</Text></div>
            }
          }
        });

        cartObj.amount = amount;
        cartObj.contentDescriptions = contentItems;
        if (deletedItem) {
          cartObj.deletedDescriptionList = deletedDescNodes;
        }
        cartObj.archiveMode = archive;
      }
      cartsList.push(cartObj);
    }

    return (
      <div style={{ padding: '0', backgroundColor: '#f0f2f5', minHeight: '100vh' }}>
        <div style={{ padding: '16px 16px 8px', backgroundColor: '#fff', marginBottom: 10 }}>
          <Title level={4} style={{ margin: 0 }}>お助けカート一覧</Title>
        </div>

        {this.state.loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: 40 }}>
            <Spin size="large" />
          </div>
        ) : (
          <List
            grid={{ gutter: 16, column: 1 }}
            dataSource={cartsList}
            renderItem={item => (
              <List.Item style={{ padding: '0 10px', marginBottom: 10 }}>
                <Card 
                  size="small" 
                  title={
                    <Space>
                      <ShoppingCartOutlined style={{ color: '#1890ff' }} />
                      <Text strong>カート {item.cartNo}</Text>
                    </Space>
                  }
                  extra={
                    item.savedData ? (
                      <Button 
                        type="text" 
                        danger 
                        icon={<DeleteOutlined />} 
                        onClick={() => this.delete(item.id, item.cartName)}
                      />
                    ) : null
                  }
                  actions={item.savedData ? [
                    <Link to={"/otasuke/cart/" + item.cartNo} style={{ display: 'block', width: '100%' }}>
                      <Button type="primary" block style={{ backgroundColor: '#52c41a', borderColor: '#52c41a' }}>
                        表示
                      </Button>
                    </Link>
                  ] : undefined}
                >
                  <Row gutter={[0, 8]}>
                    <Col span={8}><Text type="secondary">保存日時</Text></Col>
                    <Col span={16}>
                      <Text>{item.date}</Text> 
                      {item.time && <Text style={{marginLeft: 8}}>{item.time}</Text>}
                    </Col>
                    
                    <Col span={8}><Text type="secondary">送信先</Text></Col>
                    <Col span={16}><Text>{item.recipient}</Text></Col>

                    <Col span={8}><Text type="secondary">名称</Text></Col>
                    <Col span={16}><Text>{item.cartName}</Text></Col>

                    <Col span={8}><Text type="secondary">内容</Text></Col>
                    <Col span={16}>
                      {item.savedData ? (
                        <>
                          {item.contentDescriptions}
                          {item.deletedDescriptionList}
                          {item.archiveMode}
                        </>
                      ) : (
                        <Text type="secondary">空です</Text>
                      )}
                    </Col>

                    <Col span={8}><Text type="secondary">金額</Text></Col>
                    <Col span={16}>
                      {item.savedData ? (
                        <Text strong>¥{item.amount > 0 ? item.amount.toLocaleString() : 0}</Text>
                      ) : (
                        <Text>-</Text>
                      )}
                    </Col>
                  </Row>
                </Card>
              </List.Item>
            )}
          />
        )}

        <Modal
          title={
            <Space>
              <ExclamationCircleOutlined style={{ color: '#faad14' }} />
              <Text strong>お助けカート削除</Text>
            </Space>
          }
          open={this.state.modal}
          onOk={() => this.modalClose(true)}
          onCancel={() => this.modalClose(false)}
          okText="OK"
          cancelText="キャンセル"
          okButtonProps={{ danger: true }}
          centered
        >
          <Text>お助けカート「{this.state.deleteCartName}」を削除します。 よろしいですか？</Text>
        </Modal>

      </div>
    )
  }
}

export default MobileOtasukeCartList;
